/**
 * 页面类
 */
export default class Page {
  constructor(page = {}) {
    this.pageId = page.pageId || 0; //页面编号
    this.pageName = page.pageName || ""; //页面名称
    this.pageLevel = page.pageLevel || 1; //页面等级(页面所在节目的层级)
    this.pageLayout = page.pageLayout || ""; //页面布局
    this.backgroundColor = page.backgroundColor || "#FFFFFF"; //背景颜色
    this.playDurationMode = page.playDurationMode || "selfDefine"; //播放模式 默认自定义
    this.playDuration = page.playDuration || 10; //播放时间
    // this.playDuration = page.playDuration || 60; //播放时间
    this.playCount = page.playCount || 1; //播放次数
    this.backgroundPic = page.backgroundPic || ""; //背景图片
    this.backgroundPicName = page.backgroundPicName;
    this.backgroundPicDeleteFlag = page.backgroundPicDeleteFlag || false; //背景图片删除标识 true 已删除
    this.backgroundType = window.backgroundType; //背景图片类型,用于判断背景图片是否用url的背景图
    this.windowList = page.windowList || []; //页面集合
    this.style = page.style || {}; //样式对象
    this.signInCfg = page.signInCfg || {}; //考勤配置信息
    this.ModuleInfoList = page.ModuleInfoList || []; //联屏节目页面布局信息
    this.backStack = []; //可后退操作步骤记录的栈
    this.forwardStack = []; //可前进操作步骤记录的栈
    // this.backStep = 0;//用于记录back和forward的位置
    this.templateId = page.templateId || ""; //模板id
    this.layoutWindowList = page.layoutWindowList || []; //布局模板信息
    this.layoutActiveId = -1; //当前激活的布局
    this.layoutAndWindow = {}; //窗口id和模板id的对应关系 new Map()不能用map对象，不支持响应式。。
    this.hasEditorWindow = false; //当前页是否编辑窗口
    this.switchEffect = page.switchEffect || "gradient"; // 页面切换动画
    this.animationBlockType = page.animationBlockType || "null"; //播放特效
    this.materialId = page.materialId; //素材id
  }
}
